// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_t4-0";